import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '@osc-utils/services/configuration.service';
import { catchError, Observable, throwError } from 'rxjs';
import { AppUpdateService } from '../../mobile/services/app-update.service';

export interface VersionErrorResponse {
  error: string;
  mandatoryVersion: string;
}

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  #router = inject(Router);
  #injector = inject(Injector);
  #configurationService = inject(ConfigurationService);

  readonly #whitelistedAppUrls: string[] = ['/access-denied', '/mobile/access-denied'];
  readonly #whitelistedApiUrls: string[] = ['/tasks/sync'];

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 403 Forbidden errors
        if (
          error.status === 403 &&
          !this.#whitelistedAppUrls.includes(this.#router.url) &&
          !this.#whitelistedApiUrls.some(url => req.url.endsWith(url))
        ) {
          const accessDeniedUrl = this.#configurationService.isMobileApp() ? '/mobile/access-denied' : '/access-denied';
          this.#router.navigateByUrl(accessDeniedUrl, { skipLocationChange: true });
        }

        // Handle 449 Retry With - App Version Too Old
        if (error.status === 449 && error.error) {
          this.handleVersionError(error.error);
        }

        return throwError(() => error);
      }),
    );
  }

  private handleVersionError(versionError: VersionErrorResponse): void {
    if (versionError.error === 'APP_VERSION_TOO_OLD' && versionError.mandatoryVersion) {
      this.#injector.get(AppUpdateService).setMandatoryVersion(versionError.mandatoryVersion);
      return;
    }
  }
}
